import Axios from "axios";
import { decodeMessage, messageTypeHeaders } from "./HeadersMethods";
import Alerts from "./Alerts";
import { createRoot } from "react-dom/client";

Axios.defaults.withCredentials = true;

Axios.interceptors.request.use(
  function (config) {
    document.body.classList.add("loading-indicator");
    config.withCredentials = true;
    const language = localStorage.getItem("language") || "es-MX";
    config.headers["Accept-Language"] = language;
    const empresa = localStorage.getItem("empresa");
    config.headers["IdEmpresaUsuario"] = empresa;
    return config;
  },
  function (error) {
    document.body.classList.remove("loading-indicator");
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  function (response) {
    document.body.classList.remove("loading-indicator");
    if (response.headers.message !== undefined) {
      response.withCredentials = true;
      const decodeMessageHeaders = decodeMessage(response.headers.message);
      const messagetype = messageTypeHeaders(response.headers.messagetype);
      const alertElement = document.createElement("div");
      document.body.appendChild(alertElement);
      const root = createRoot(alertElement);
      root.render(
        <Alerts
          error={decodeMessageHeaders}
          type={messagetype}
          onClose={() => {
            document.body.removeChild(alertElement);
          }}
        />
      );
    }

    return response;
  },

  function (error) {
    document.body.classList.remove("loading-indicator");
    if (
      (error.response && error.response.status === 401) ||
      (error.response && error.response.status === 404)
    ) {
      logout(() => {
        const loginUrl =
          process.env.NODE_ENV === "production"
            ? "/TransMex/Web/Account/Login"
            : "/Account/Login";

        window.location.href = loginUrl;
        const alertElement = document.createElement("div");
      document.body.appendChild(alertElement);
      const root = createRoot(alertElement);
      root.render(
        <Alerts
          error="Tu sesión ha expirado debido a inactividad. Por favor, vuelve a iniciar sesión para continuar. "
          type="error"
          onClose={() => {
            document.body.removeChild(alertElement);
          }}
        />);
        return Promise.resolve(error);
      });
    }
    if (error.response.headers.message !== undefined) {
      const decodeMessageHeaders = decodeMessage(
        error.response.headers.message
      );
      const messagetype = messageTypeHeaders(
        error.response.headers.messagetype
      );
      const alertElement = document.createElement("div");
      document.body.appendChild(alertElement);
      const root = createRoot(alertElement);
      root.render(
        <Alerts
          error={decodeMessageHeaders}
          type={messagetype}
          onClose={() => {
            document.body.removeChild(alertElement);
          }}
        />
      );

      return Promise.resolve(error);
    }
    return Promise.reject(error);
  }
);

const logout = (redirectCallback) => {
  document.cookie.split(";").forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
  localStorage.clear();

  redirectCallback();
};

export default Axios;
